<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>

      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Perfil laboral</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>PL_01_admin_PerfilLab</div>
        </b-col>
      </b-row>

      <b-row> 
        <b-col class="subtitulos">
          Administración de especialidades
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label for="nombreBusq">Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombre" placeholder="Nombre de la especialidad"
                                v-model="filtro.palabraClave" @keydown.enter.native="obtenerEspecialidades"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>

            <b-col></b-col>

            <b-col align="right" v-if="$localStorageService.can('PL_01_admin_alta_PerfilLab')">
              <b-button v-b-tooltip.hover title="Crear menú" variant="outline-success"
                        @click="agregar()">Crear especialidad
              </b-button>
            </b-col>

          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                    title="Detalle del perfil"
                    size="sm"
                    @click="detalle(row.item)"
                    variant="outline-danger"
                ><em class="fa fa-eye"></em></b-button>
                <b-button
                    v-if="$localStorageService.can('PL_01_admin_modif_PerfilLab')"
                    title="Modificar perfil"
                    size="sm"
                    @click="modificar(row.item)"
                    variant="outline-warning"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button v-if="!row.item.registroActivo && $localStorageService.can('PL_01_admin_react_PerfilLab')"
                          title="Activar perfil"
                          variant="outline-danger"
                          size="sm"
                          @click="eliminar(row.item)"
                ><em class="fa fa-undo"></em></b-button>
                <b-button v-else-if="$localStorageService.can('PL_01_admin_baja_PerfilLab')"
                          title="desactivar perfil"
                          variant="outline-danger"
                          size="sm"
                          @click="eliminar(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>

            </template>
              <template v-slot:cell(Replica)="row">
              <b-form-checkbox
                  @change="activarDesactivarReplica(row.item)"
                  v-model="row.item.replica"
                  name="check-button" switch>
              </b-form-checkbox>
            </template>
            <template v-slot:cell(OgCabecera)="row" v-if="$localStorageService.can('PL_01_Asig_OG_cab')">
              <b-form-checkbox
                  @change="activarDesactivarOgCabecera(row.item)"
                  v-model="row.item.ogCabercera"
                  name="check-button" switch>
              </b-form-checkbox>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>


      </b-row>

    </b-container>


    <b-modal
        v-model="show"
        :title="tituloModal"
        no-close-on-backdrop
        size="lg"
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group align="left">
                <label for="nombreMenu">Nombre
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input id="nombreMenu" name="nombreMenu" placeholder="Nombre de la especialidad"
                                v-model="$v.especialidad.especialidad.$model"
                                :state="validateState('especialidad')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group align="left">
                <label for="nombreMenu">Color
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <v-select id="nombreMenu" name="nombreMenu" placeholder="Color de la especialidad"
                            v-model="$v.especialidad.idColor.$model"
                            label="nombre"
                            style="width: 95%"
                            :reduce="(variable) => variable.idColor"
                            :options="colores"
                            :state="validateState('idColor')"
                  >
                    <template v-slot:option="option">
                      <em class="fa fa-circle" :style="{color: option.codigo}"> </em> {{ option.nombre }}

                    </template>
                  </v-select>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                 <label>Orden Laboratorio</label>
                 <b-form-checkbox
                  v-model="especialidad.ordenLaboratorio"
                  name="check-button" switch>
              </b-form-checkbox>
              </b-form-group>
              <b-form-group align="left">
                <label for="permiso">Tratamientos
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="card-checklist"></b-icon>
                  </b-input-group-prepend>
                  <v-select id="Tratamientos" name="Tratamientos" placeholder="Tratamientos"
                            label="nombre"
                            multiple
                            :options="tratamientos"
                            v-model="especialidad.tratamientos"
                            :state="validateState('tratamientos')"
                            style="width: 95%"
                  ></v-select>
                </b-input-group>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardar()">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </div>
    </b-modal>

    <b-modal
        v-model="showDetalle"
        :title="'Detalle de la especialidad'"
        size="lg"
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <div v-if="menuDetalle !== null">
              <b-form-group align="left">
                <label>Nombre
                </label>
                <p>{{ menuDetalle.especialidad }}</p>
              </b-form-group>

              <b-form-group align="left">
                <label>Tratamientos </label>
                <ul>
                  <li v-for="(item, index) in menuDetalle.tratamientos " :key="item.nombre+index">{{ item.nombre }}</li>
                </ul>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-danger" @click="cerrarModal()">Cerrar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Header from "../../components/Header";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";

export default {
  name: "especialidades",
  components: {
    Header
  },
  mixins: [validationMixin],
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTabla: [],
      fields: [
        {key: "id", label: "ID", sortable: true},
        {key: "especialidad", label: "Especialidad", sortable: true},
        "Acciones",
        "Replica",
        "OgCabecera"
      ],
      registrosPorPagina: 10,
      paginaActual: 0,
      show: false,
      showDetalle: false,
      tituloModal: '',
      especialidad: {
        idEspecialidad: null,
        nombre: null,
        idColor: null,
        tratamientos: null,
        registroActivo: null
      },
      menuDetalle: null,
      tratamientos: [],
      loaderAcciones: false,
      loader: false,
      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null
      },
      menuslista: [],
      colores: []
    }
  },
  validations: {
    especialidad: {
      especialidad: {required},
      idColor: {required},
      tratamientos: {required}
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerEspecialidades();
    this.obtenerColores();
    this.obtenertratamientos();
  },
  methods: {
   activarDesactivarReplica (item) {
          this.$http
            .post(
              this.$api +
                "especialidad/activarReplicaEspecialidad?idEspecialidad=" +
                item.id
            )
            .then((respuesta) => {
              if (respuesta.data.data) {
                
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "La parametrización de replica se actualizó correctamente",
                });
              }
            }).catch((error) => {
            console.error(error);
                this.$swal.fire({
                  icon: "warning",
                  title: "Aviso",
                  text: "Ocurrió un error, por favor vuelva a intentarlo",
                });
            });
   
    },
    obtenerEspecialidades() {
      this.loader = true
      this.datosTabla = [];
      this.$http.post(this.$api + 'especialidad/listaEspecialidades', this.filtro).then(respuesta => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data
            }
          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },
    obtenertratamientos() {
      this.$http.get(this.$api + 'planConvenio/obtener/tratamientos/categoria').then(
          respuesta => {
            if (respuesta.data.data) {
              this.tratamientos = respuesta.data.data;
            }

          }
      )
    },
    obtenerColores() {
      this.$http.get(this.$api + 'catalogos/listaColores').then(
          respuesta => {
            if (respuesta.data.data) {
              this.colores = respuesta.data.data;
            }

          }
      )
    },
    detalle(item) {
      this.menuDetalle = item;

      this.showDetalle = true;
    },
    agregar() {
      this.especialidad = {
        id: null,
        especialidad: null,
        tratamientos: null,
        registroActivo: null
      };
      this.tituloModal = 'Agregar especialidad';
      this.show = true;
    },
    guardar() {
      this.$v.especialidad.$touch();
      if (this.$v.especialidad.$anyError) {
        return;
      }
      if (!this.$v.especialidad.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'especialidad/guardar', this.especialidad).then(respuesta => {
              if (respuesta.data.data) {
                this.obtenerEspecialidades();
                this.show = false;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "La especialidad se guardó correctamente",
                });
              }
            }
        ).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }
    },
    modificar(item) {
      this.especialidad = item;
      this.tituloModal = 'Modificar especialidad';
      this.show = true;
    },

    eliminar(item) {
      const mensaje = item.registroActivo ? '¿Está seguro de desactivar la especialidad?' : '¿Está seguro de activar la especialidad?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            id: item.id,
          };
          this.$http.post(this.$api + 'especialidad/eliminar', parametros).then(respuesta => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "La especialidad se actualizó correctamente",
                  });
                }
              }
          )
        }
      })
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.especialidad[name];
      return $dirty ? !$error : null;
    },
    cerrarModal() {
      this.showDetalle = false;
      this.show = false;
    },
    activarDesactivarOgCabecera(especialidad) {
      if (especialidad.id !== null) {
        const parametros = {
          id: especialidad.id,
        };
        this.$http.post(this.$api + 'especialidad/activarOgCabecera', parametros).then(respuesta => {
              if (respuesta.data.data) {
                especialidad.ogCabecera = ! especialidad.ogCabecera;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "El og general se actualizó correctamente",
                });
              }
            }
        )
      }
    }
  },
  mounted() {
    this.registrosPorPagina = this.$registrosPorPaginaTabla;
  }
}
</script>

<style scoped>

</style>
